import { render, staticRenderFns } from "./pre.vue?vue&type=template&id=5154fa26&"
import script from "./pre.vue?vue&type=script&lang=js&"
export * from "./pre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports